import React, { Component } from 'react';
import ReactTable from 'react-table';
import Loading from '../UI_Elements/Loading';
import 'moment/locale/sv';
import 'react-datepicker/dist/react-datepicker.css';

class PopupVerify extends Component {
  constructor(props) {
    super(props);

    this.state = {
      forgotemail: "",
      activeView: 'confirmView',
      tableVisible: false
    };

    this.nextView = this.nextView.bind(this);
    this.toggleTableVisibility = this.toggleTableVisibility.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleOutsideClick = this.handleOutsideClick.bind(this);
  }

  countPallets(orders) {
    return Math.ceil(orders.length / 3)
  }

  countWeight(orders) {
    return orders.length * 80;
  }

  toggleTableVisibility(e) {
    e.preventDefault()
    this.setState({
      tableVisible: !this.state.tableVisible
    })
  }

  handleChange = event => {
    this.setState({
      [event.target.id]: event.target.value
    });
  }

  nextView() {
    if (this.state.activeView === 'confirmView')
      this.setState({activeView: 'verifyView'})

    if (this.state.activeView === 'verifyView') {
      this.setState({activeView: 'completedView'})
    }
  }

  handleSubmit = (event) => {
    event.preventDefault();
    this.props.submit(event)
  }

  handleOutsideClick(e) {
    if (e.target === e.currentTarget && !this.props.sending) {
      this.props.closePopup()
    }
  }

  render() {
    const confirmView = (
      <div>
        <span className='cursive'>Skickas från</span>
        <h1>{this.props.info.fromStationName}</h1>
        <div>
          <span className='bold'>Stationsnummer: </span>{this.props.info.retailerId}
        </div>
        <div>
          <span className='bold'>Adress: </span>{this.props.info.fromAddress}
        </div>
        <div>
          <span className='bold'>Postadress: </span>
          {this.props.info.fromPostalCode} {this.props.info.fromCity}
        </div>

        <hr />

        <span className='cursive'>Kontaktperson</span>
        <h1 className='green'>{this.props.info.contact}</h1>
        <div>
          <span className='bold'>Mobil: </span>{this.props.info.contactPhone}
        </div>

        <button onClick={this.nextView} className='next'>Vidare</button>
      </div>
    )

    const verifyView = (
      <div>
        <button className='close' onClick={this.props.closePopup}></button>
        
        <h1>Verifiera</h1>

        <div className='table orders-to-verify'>
          <ReactTable
            data={this.props.data}
            columns={[
              {
                Header: "Regnr",
                accessor: "regnr",
                width:90,
              },
              {
                Header: "Bilmodell",
                accessor: "bilmodell",
                width:220

              },
              {
                Header: "Hjulmodell",
                accessor: "hjulmodell",
                width:100
              },
              {
                Header: "Last on rent",
                accessor: "lastOnRentDate",
              }
            ]}
            defaultPageSize={this.props.data.length}
            className={this.props.data.length < 5 || this.state.tableVisible ? 'visible' : 'hidden'}
            showPagination={false}
            noDataText='Inga däck tillagda i ordern'
          />
          {
            this.props.data.length >= 5 ?
              <button
                onClick={this.toggleTableVisibility.bind(this)}>
                {this.state.tableVisible ? 'Dölj' : 'Visa alla'} ({this.props.data.length})
              </button> : null
          }
        </div>
        
        <h1>
          Ordernummer {this.props.info.id} - {this.props.info.pallets} {this.props.info.pallets === 1 ? 'pall' : 'pallar'} - {this.props.info.weight}kg
        </h1>

        <hr />

        <div className='row'>
        <div className='col-left'>
            <div>
              <span className='bold'>{this.props.info.fromStationName}</span>
            </div>
            <div>
              <span className='bold'>Upphämtningsadress: </span>{this.props.info.fromAddress}
            </div>
            <div>
              <span className='bold'>Postadress: </span>
              {this.props.info.fromPostalCode} {this.props.info.fromCity}
            </div>
          </div>
          <div className='arrow'>
            <span></span>
          </div>
          <div className='col-right'>
            <div>
              <span className='bold'>{this.props.info.toStationName}</span>
            </div>
            <div>
              <span className='bold'>Leveransadress: </span>{this.props.info.toAddress}
            </div>
            <div>
              <span className='bold'>Postadress: </span>
              {this.props.info.toPostalCode} {this.props.info.toCity}
            </div>
          </div>
        </div>

        <hr />

        <div className='comment'>
          <span className='bold'>Ev kommentar: </span>
          <input
            type='text'
            maxLength='250'
            placeholder='Ev kommentar (max 250 tecken)'
            onChange={this.props.handleCommentChange}
          />
        </div>

        <hr />

        <div className='confirm'>
          <button
            onClick={this.handleSubmit}
            name='confirm-order'>
            Bekräfta
          </button>
        </div>
      </div>
    )

    return (
      <div
        className='popup verify'
        name='popupOverlay'
        onClick={this.handleOutsideClick}
      >
        <div className='popup_inner verify'>
            <Loading show={this.props.sending} />
          <button className='close' onClick={this.props.closePopup}></button>

          {this.state.activeView === 'confirmView' ? confirmView : null}
          {this.state.activeView === 'verifyView' ? verifyView : null}
          {/* {this.state.activeView === 'completedView' ? completedView : null} */}

        </div>
      </div>
    );
  }
}

export default PopupVerify


// WEBPACK FOOTER //
// ./src/components/Orders/PopupVerify.js